import { render, staticRenderFns } from "./openrange.vue?vue&type=template&id=0893fa08&scoped=true"
import script from "./openrange.vue?vue&type=script&lang=js"
export * from "./openrange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0893fa08",
  null
  
)

export default component.exports